import React from 'react';
import styles from '../styles/Hamburger.module.css';

const Hamburger = ({ isOpen, onClick }) => (
  <button
    type="button"
    className={`${styles.button}${isOpen ? ` ${styles.open}` : ''}`}
    onClick={onClick}
    aria-label={isOpen ? 'Close navigation menu' : 'Open navigation menu'}
    aria-expanded={isOpen}
    aria-controls="main-navigation"
  >
    <span />
    <span />
    <span />
  </button>
);

Hamburger.defaultProps = {
  isOpen: false,
  onClick: () => {},
};

export default Hamburger;
